import { Link } from 'react-router-dom';
import type { JSX } from 'react';
import styles from './Footer.module.css';

const Footer = (): JSX.Element => {
  return (
    <footer className={styles.footer}>
      <div className={styles.socials}>
        <a
          href=" https://www.linkedin.com/company/slayd-app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/images/social/linkedin-logo.png"
            alt="Logo 1"
            className={styles.logo}
          />
        </a>
        <a
          href="https://www.instagram.com/slayd_finds/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/images/social/instagram-logo.png"
            alt="Slayd Instagram"
            className={styles.logo}
          />
        </a>
        <a
          href="https://in.pinterest.com/slaydapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/images/social/pinterest-logo.png"
            alt="Logo 3"
            className={styles.logo}
          />
        </a>
      </div>
      <div className={styles.footerDetails}>
        <Link to="/about">About Us</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <a href="mailto:hello@slayd.in">Contact Us</a>
      </div>
      <div className={styles.copyrightContent}>
        © 2025 Slayd Technologies Pvt. Ltd.
      </div>
    </footer>
  );
};

export default Footer;
